import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Card, DropdownButton, Row, Col, Nav } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons';

import SurveyProperty from './survey_property';
import SurveyCsvExporter from './survey_csv_exporter';
import CsvDownloadButton from  'components/csv_download_button';
import EmptyState from 'shared/empty_state';

const TABS = {
  potential: 0,
  rejected: 1
};

export default class SurveyTab extends React.Component {
  static propTypes = {
    addBuySurveyPropertyPath: PropTypes.string,
    addLeaseSurveyPropertyPath: PropTypes.string,
    projectId: PropTypes.number,
    removeSurveyProperty: PropTypes.func.isRequired,
    surveyProperties: PropTypes.array.isRequired,
    surveyPropertyCsvColumns: PropTypes.object,
    surveysPath: PropTypes.string,
    toggleReject: PropTypes.func.isRequired
  }

  state = {
    exportingCsv: false,
    tab: TABS.potential
  }

  switchTab = (tab) => {
    this.setState({ tab });
  }

  activeProperties = () => {
    return this.props.surveyProperties.filter((property) => {
      return property.rejected === false;
    });
  }

  surveyProperties = () => {
    return this.props.surveyProperties.filter((property) => {
      return property.rejected === (this.state.tab !== TABS.potential);
    });
  }

  renderAddSurveyPropertyButton() {
    if (this.props.addBuySurveyPropertyPath && this.props.addLeaseSurveyPropertyPath) {
      return (
        <DropdownButton id="addSurveyPropertyDropdown" title="Add New Location">
          <Dropdown.Item
            eventKey="1"
            href={this.props.addLeaseSurveyPropertyPath}
            name="addSurveyPropertyLink"
          >
            Lease Location
          </Dropdown.Item>
          <Dropdown.Item
            eventKey="2"
            href={this.props.addBuySurveyPropertyPath}
            name="addSurveyPropertyLink"
          >
            Buy Location
          </Dropdown.Item>
        </DropdownButton>
      );
    }

    return (
      <React.Fragment>
        {this.props.addLeaseSurveyPropertyPath &&
          <a
            className="btn btn-primary"
            href={this.props.addLeaseSurveyPropertyPath}
            name="addSurveyPropertyLink"
          >
            Add Lease
          </a>
        }
        {this.props.addBuySurveyPropertyPath &&
          <a
            className="btn btn-primary"
            href={this.props.addBuySurveyPropertyPath}
            name="addSurveyPropertyLink"
          >
            Add Buy
          </a>
        }
      </React.Fragment>
    );
  }

  renderHeader() {
    return (
      <React.Fragment>
        <Row className="align-items-center">
          <Col>
            <h5>Survey</h5>
          </Col>
          <Col className="d-flex gap-2 align-items-center" xs="auto">
            <CsvDownloadButton entityName='surveys' onClick={() => this.setState({ exportingCsv: true })}/>
            {this.renderAddSurveyPropertyButton()}
          </Col>
        </Row>
        <Nav activeKey={this.state.tab} onSelect={selectedKey => this.switchTab(selectedKey)} variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey={TABS.potential}>Potential Locations</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey={TABS.rejected}>Rejected Locations</Nav.Link>
          </Nav.Item>
        </Nav>
      </React.Fragment>
    );
  }

  renderEmptyState() {
    return (
      <EmptyState
        bodyText='Click "Add Location" to add your first location.'
        header="You don't have any locations yet!"
        icon={faBuilding}
      />
    );
  }

  renderSurveyProperties() {
    if (this.surveyProperties().length === 0) {
      return this.renderEmptyState();
    }
    return this.surveyProperties().map((property) => {
      return (
        <SurveyProperty
          key={property.id}
          name='survey-property-row'
          projectId={this.props.projectId}
          property={property}
          removeSurveyProperty={this.props.removeSurveyProperty}
          toggleReject={this.props.toggleReject}
        />
      );
    });
  }

  renderCsvExporter() {
    return (
      <Card>
        <Card.Body>
          <SurveyCsvExporter
            surveyPropertyCount={this.activeProperties().length}
            surveyPropertyCsvColumns={this.props.surveyPropertyCsvColumns}
            surveysPath={this.props.surveysPath}
            onCancel={() => this.setState({ exportingCsv: false })}
          />
        </Card.Body>
      </Card>
    );
  }

  render() {
    if (this.state.exportingCsv) return this.renderCsvExporter();
    return (
      <div>
        <div className="mb-4">
          {this.renderHeader()}
        </div>
        {this.renderSurveyProperties()}
      </div>
    );
  }
}
